import * as types from './types';

export function onConnectionStateChange(isConnected) {
  return {
    type: types.ON_CONNECTION_STATE_CHANGED,
    payload: { isConnected: isConnected }
  };
}

export function initConnection(firebaseApp) {
  return function (dispatch) {
    firebaseApp.database().ref('.info/connected').on('value', function (snapshot) {
      dispatch(onConnectionStateChange(snapshot.val()));
    });
  };
}

export function unsubscribeConnection(firebaseApp) {
  return function (dispatch) {
    firebaseApp.database().ref('.info/connected').off();
    onConnectionStateChange(false);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/connection/actions.js
// module id = 689
// module chunks = 49